import { assignNewPrintBatchIdEndpoint } from './endpoints';

const assignNewPrintBatchId = async (tokenMemo, orderId) => {
  const token = await tokenMemo;

  const response = await fetch(assignNewPrintBatchIdEndpoint(orderId), {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
  if (response.ok) {
    return { success: true };
  }
  const err = await response.json();
  throw new Error(err.error || 'Could not assign order to new print batch');
};

export default assignNewPrintBatchId;
